import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { cancelRemoteAction } from '../actions/remoteactions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from '../store'

import RemoteActionStatusBadge from './RemoteActionStatusBadge'

class RemoteActionsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      deleting: false,
      deleteConfirmShown: false,
      deleteId: null,
      result: '',
      resultShown: false
    }

    this.resultToggle = this.resultToggle.bind(this)
    this.resultShow = this.resultShow.bind(this)
    this.delete = this.delete.bind(this)
    this.deleteConfirmShow = this.deleteConfirmShow.bind(this)
    this.deleteConfirmToggle = this.deleteConfirmToggle.bind(this)
  }

  delete() {
    const { cancelRemoteAction } = this.props

    this.setState({ deleting: true, deleteConfirmShown: false })
    cancelRemoteAction(this.state.deleteId)
  }

  deleteConfirmShow(id) {
    this.setState({
      deleteConfirmShown: true,
      deleteId: id
    })
  }

  deleteConfirmToggle() {
    this.setState({ deleteConfirmShown: !this.state.deleteConfirmShown })
  }

  resultToggle() {
    this.setState({ resultShown: !this.state.resultShown })
  }

  resultShow(result, e) {
    this.setState({ result: result, resultShown: true })
  }

  render() {

    if (this.props.remoteActions.loading) {
      return (<div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    if (this.props.remoteActions.error) {
      return (<div className="od-remote-error">Error al cargar las acciones remotas</div>)
    }

    const actions = Array.isArray(this.props.remoteActions.remoteActions)
      ? this.props.remoteActions.remoteActions
      : []

    if (actions.length === 0) {
      return (
        <div className="od-ra-empty">
          <i className="fas fa-inbox fa-2x"></i>
          <p>No hay acciones remotas registradas</p>
        </div>
      )
    }

    return (
      <div>
        <div className="od-ra-list">
          {actions.map(ra => (
            <div key={ra._id} className="od-ra-row">
              <div className="od-ra-status">
                <RemoteActionStatusBadge status={ra.status} />
              </div>
              <div className="od-ra-code">
                <span className="od-ra-code-tag">{ra.code}</span>
                {ra.arguments && ra.arguments !== 'vacway' && (
                  <span className="od-ra-args">{ra.arguments}</span>
                )}
              </div>
              <div className="od-ra-meta">
                <span className="od-ra-date">
                  <i className="fas fa-clock fa-xs"></i>
                  {new Date(ra.date).toLocaleString('es-ES', { timeZone: 'Europe/Madrid', hour12: false })}
                </span>
                <span className="od-ra-executor">
                  <i className="fas fa-user fa-xs"></i>
                  {ra.executor}
                </span>
              </div>
              <div className="od-ra-actions">
                <button className="od-ra-btn od-ra-btn-view" title="Ver resultado"
                  onClick={e => this.resultShow(ra.result, e)}>
                  <i className="fas fa-eye"></i>
                </button>
                <button className="od-ra-btn od-ra-btn-cancel" title="Cancelar"
                  onClick={() => this.deleteConfirmShow(ra._id)}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        <Modal isOpen={this.state.resultShown}>
          <ModalHeader toggle={this.resultToggle}>Resultado</ModalHeader>
          <ModalBody>
            <p className="text-break text-monospace">
              {this.state.result}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.resultToggle}>Cerrar</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.deleteConfirmShown} toggle={this.deleteConfirmToggle}>
          <ModalHeader toggle={this.deleteConfirmToggle}>Confirmar</ModalHeader>
          <ModalBody>
            <p>¿Estás seguro de cancelar la acción remota?</p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary mr-1" onClick={this.delete}>Sí</Button>
            <Button color="secondary" onClick={this.deleteConfirmToggle}>No</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  remoteActions: state.remoteactions
})

const mapDispatchToProps = dispatch => ({
  cancelRemoteAction: bindActionCreators(cancelRemoteAction, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(RemoteActionsList)

